<button
  type="button"
  (click)="click()"
  (keydown)="keydown($event)"
  (blur)="resetStatus()"
  i18n-aria-label="@@Common.label.help-button"
  aria-label="more info">
  <svg-icon icon="icon_help_full" />
  @if (displayText()) {
    <svg class="pointer" viewBox="0 0 20 10">
      <path d="M0 0L10 10L20 0" />
    </svg>
  }
</button>
<span role="status">
  @if (displayText()) {
    <span>{{ text() }}</span>
  }
</span>
